var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"facebook","transform":"translate(-1200 -6008)"},React.createElement("g",{"id":"Facebook-2","data-name":"Facebook","transform":"translate(1200 6008)"},React.createElement("path",{"id":"Combined-Shape","d":"M12.5,25A12.5,12.5,0,0,1,7.635.982a12.5,12.5,0,0,1,9.731,23.035A12.421,12.421,0,0,1,12.5,25ZM9.583,10.706V13.05h1.406v6.8H13.8v-6.8H15.68l.249-2.344H13.8l0-1.173c0-.6.043-.939.936-.939h1.173V6.25H14.038a3.052,3.052,0,0,0-2.37.808A3.191,3.191,0,0,0,10.989,9.3v1.407Z","transform":"translate(0 0)","fill":"#231f20"}))));
}

Facebook.defaultProps = {"width":"25","height":"25","viewBox":"0 0 25 25"};

module.exports = Facebook;

Facebook.default = Facebook;
